import { render, staticRenderFns } from "./is_save_two.vue?vue&type=template&id=5e70b91a&scoped=true&"
import script from "./is_save_two.vue?vue&type=script&lang=js&"
export * from "./is_save_two.vue?vue&type=script&lang=js&"
import style0 from "./is_save_two.vue?vue&type=style&index=0&id=5e70b91a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70b91a",
  null
  
)

export default component.exports